<script lang="ts" context="module">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr } from '../../../common/util';
  import PdpServiceMiniCard from './PDPServiceMiniCard.svelte';

  const { currency } = getAppConfig();
  const whatsincluded = getStr('extra.pdp.service.whatsincluded');
</script>

<script lang="ts">
  export let data: any;
  export let labelData: any;
  export let lmdConfigurations: any; // used as the componentName to render

  $: component = lmdConfigurations;
</script>

<PdpServiceMiniCard data={labelData} serviceBlockType={data.serviceBlockType}>
  <svelte:component this={component} {currency} vasEntry={data} headerLabel={whatsincluded} serviceBlock={labelData} />
</PdpServiceMiniCard>
